// {@see CdnParser}

module.exports = {
  cdnName: 'HIGHNEGR',
  parsers: [{
    element: 'host+type',
    headerName: 'X-HW',
    regex: /.+,[0-9]+\.(.+)\.(.+)/
  }],
  parseType: function (type) {
    switch (type) {
      case 'c':
      case 'x':
        return 1
      default:
        return 2
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./src/comm/transform/resourceparsers/cdnparsers/highwinds.js
// module id = 34
// module chunks = 0